import React, { useEffect, useState, lazy, Suspense } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Modal,
  Container,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap"
import { useSelector, useDispatch } from "react-redux"
import { removeCard, defaultCard, resetCardAlert } from "../../../../store/actions"
import CardIcon from "../../../../assets/images/lystfacelogos/BillingDetails/paymentCardIcon.svg"
import delCardLogo from "../../../../assets/images/lystfacelogos/BillingDetails/delete-card-icon.svg"
import { Elements } from "@stripe/react-stripe-js"
// import CreditCard from "../../Payment/CreditCard"
import SmallLoader from "../../../Common/SmallLoader"
import CustomLoader from "../../../Common/CustomLoader"
import { CustomToast } from "../../Common/CustomToast"
import withRouter from "../../../Common/withRouter"
import StripeProvider from "../../../Common/StripeProvider"
import CustomPopup from "../../../Common/CustomPopup"
import { useNavigate } from "react-router-dom"
import ActiveMoreIcon from "../../../../assets/images/lystfacelogos/ActiveMoreIcon.svg"
import InactiveMoreIcon from "../../../../assets/images/lystfacelogos/InactiveMoreIcon.svg"
import CrossIcon from "../../../../assets/images/lystfacelogos/CrossIcon.svg"
import InvalidIcon from "../../../../assets/images/lystfacelogos/InvalidIcon.svg"



let cardDetails = [
  { card_name: "Mindsbeam ICICI", last_4: 2456, default: true },
  { card_name: "Mindsbeam Kotak credit card", last_4: 2456, default: false },
]

const CreditCard = lazy(() => import('../../Payment/CreditCard'));
const stripeApiKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY;


const SavedCards = ({
  cardList,
  cardListLoading,
  cardAddLoading,
  cardAdded,
  repMessage,
  addCardErr,
  defCardErr,
  remCardErr,
  defaultCardLoading,
  cardRemoveLoading,
  ...props
}) => {
  const dispatch = useDispatch()

  const [modal_center, setmodal_center] = useState(false)
  const [popupDetails, setPopupDetails] = useState({ open: false })
  const navigate = useNavigate();
  const BillingState = useSelector(state => state.BillSet)
  const { billAddressLoading, billAddress, cardAddLoadingForPaymentInfo } = BillingState
  const [dropdownopen, setDropdownopen] = useState(false)
  const [activedropdownopen, setActiveDropdownopen] = useState(null)
  const [validationMessage, setValidationMessage] = useState(null)
  const [selectedDropdown, setSelectedDropdown] = useState()

  useEffect(() => {
    if (cardRemoveLoading) {
      setPopupDetails({ ...popupDetails, primaryLoading: cardRemoveLoading })

    }
    else {
      setPopupDetails({ open: false })
    }
  }, [cardRemoveLoading])

  function tog_center() {
    setmodal_center(!modal_center)
  }
  function close_model() {
    setmodal_center(false)
  }

  const onClickDeleteCard = (cd) => {
    setSelectedDropdown("remove_card")
    if (cd.default) {
      setValidationMessage("Please set a new default payment method to remove the existing card!")

    }
    else if (!defaultCardLoading) {
      setValidationMessage(null)
      setPopupDetails({
        open: true, title: cd, titleText: 'Delete card', bodyText: `Are you sure you want to delete the card that ends with ${cd.card.last4}?`, primaryButtonText: 'Delete', secondaryButtonText: 'Cancel', handleClickPrimaryButton: onRemoveCard, handleClickSecondaryButton: handleCloseModal
      })
    }

  }

  const handleCloseModal = () => {
    setPopupDetails({ open: false })
  }

  const onRemoveCard = cdDetails => {
    // setPopupDetails({ open: false, cdDetails: cdDetails })
    const remPayMeth = {
      payment_method_id: cdDetails.id,
    }
    if (!cardRemoveLoading) {
      dispatch(removeCard(remPayMeth))

    }
  }
  const onDefaultCard = cdDetails => {
    setSelectedDropdown("default_card")
    setPopupDetails({ open: false, cdDetails: cdDetails })
    const defPayMeth = {
      payment_method_id: cdDetails.id,
    }
    if (!defaultCardLoading) {
      dispatch(defaultCard(defPayMeth))

    }
  }
  useEffect(() => {
    if (cardAdded) {
      close_model()
    }
  }, [cardAdded])

  useEffect(() => {
    if (repMessage !== null && addCardErr !== null && (addCardErr ? false : cardList?.count > 1)) {
      CustomToast({
        message: repMessage,
        status: addCardErr ? 'failure' : 'success',
        closeToast: () => {
          console.log('Toast closed');
        },
      })
    }
    if (repMessage !== null && defCardErr !== null) {
      CustomToast({
        message: repMessage,
        status: defCardErr ? 'failure' : 'success',
        closeToast: () => {
          console.log('Toast closed');
        },
      })
    }
    if (repMessage !== null && remCardErr !== null) {
      CustomToast({
        message: repMessage,
        status: remCardErr ? 'failure' : 'success',
        closeToast: () => {
          console.log('Toast closed');
        },
      })
    }
    dispatch(resetCardAlert())

  }, [addCardErr, defCardErr, remCardErr, cardList?.count])



  useEffect(() => {
    if (selectedDropdown && !defaultCardLoading) {
      setDropdownopen(false)
      setSelectedDropdown(null)
      setActiveDropdownopen(null)

    }
  }, [selectedDropdown, defaultCardLoading])

  const stripe = StripeProvider(stripeApiKey);
  return (
    <React.Fragment>
      <div className="mt-3"
      >
        <div className="billing-details d-flex align-items-center justify-content-between ">
          <span className="title">{cardList?.count > 0 && !billAddressLoading ? `Saved cards (${cardList?.count})` : "Card details"}</span>
          {cardList?.count > 0 && !billAddressLoading &&
            <div>
              <button
                className="button"
                type="button"
                onClick={() => {
                  tog_center()
                }}
                data-toggle="modal"
                data-target=".bs-example-modal-center"
              >
                Add new card
              </button>
            </div>
          }

        </div>
        {validationMessage && <div className="validation-message-container">
          <div className="messsage-container">
            <img className="invalid-icon" src={InvalidIcon} />
            <span className="message">{validationMessage}</span>
          </div>

          <div className="close-icon" onClick={() => setValidationMessage(null)}>
            <img src={CrossIcon} />
          </div>
        </div>}


      </div>
      {modal_center &&
        <Modal
          className="model-card mx-auto"
          isOpen={modal_center}
          // toggle={() => {
          //   // tog_center()
          // }}
          centered={true}
        >
          <div className="model-header-custom">
            <span className="title">Add new card</span>
            <button
              type="button"
              onClick={() => {
                setmodal_center(false)
              }}
              className="close button"
              data-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <Suspense fallback={<CustomLoader text="Loading..." />}>
            {stripe && (
              <Elements stripe={stripe} >
                <CreditCard closeModel={close_model} cardAddLoading={cardAddLoading} cardAdded={cardAdded} cardList={cardList} />
              </Elements>
            )}
          </Suspense>
        </Modal>
      }
      {(cardList?.count === 0 && !cardListLoading && (cardListLoading || !stripe)) ? (
        <CustomLoader className="stripe-loading" text={"Rendering stripe elements..."} />

      )
        :

        ((cardList?.count === 0 && !cardListLoading) || (billAddressLoading && cardAddLoadingForPaymentInfo) && stripe) ?

          <Suspense fallback={<CustomLoader className="stripe-loading" text="Rendering stripe elements..." />}>
            {stripe && (
              <Elements stripe={stripe} >
                <CreditCard closeModel={close_model} cardAddLoading={cardAddLoading} cardAdded={cardAdded} from="payment-information" cardList={cardList} />
              </Elements>
            )}
          </Suspense>
          :
          <div id="custom-container">

            <div className={`saved-cards ${cardList?.count > 5 ? "scroll-view" : ""}`} >
              {!cardAddLoadingForPaymentInfo && cardList.list.map((cd, index) => (
                <div
                  key={cd.id}

                  className={`d-flex ${index != 0 ? "mt-3" : ""} flex-column flex-sm-row justify-content-sm-between align-items-center saved-cardS ${index !== cardList.list.length - 1 && `border-bottom-saved-cards`
                    }`}
                >
                  <div className="d-flex">
                    <img src={CardIcon} className="me-3 card-icon" />
                    <div className="me-3 card-details">
                      <div className="name">Stripe Test Card</div>
                      <div className="last-digit">****{cd.card.last4}</div>
                    </div>
                    <div className="ms-auto">
                      <span className={cd.default ? `badge-primary` : ``}>
                        {cd.default &&
                          <span className="text">
                            {cd.default ? `Default` : `Saved`}
                          </span>
                        }
                      </span>
                    </div>
                  </div>

                  {

                    <Dropdown
                      isOpen={dropdownopen && cd.id === activedropdownopen}
                      toggle={() => {
                        if (dropdownopen) {
                          setDropdownopen(!dropdownopen);
                          setActiveDropdownopen(null)

                        }
                        else {
                          setDropdownopen(!dropdownopen);
                          setActiveDropdownopen(cd?.id)
                        }

                      }
                      }
                      className="dropdown-icon"
                    >
                      <DropdownToggle
                        className="dropdown-toggle"
                        id="page-header-user-dropdown"
                        tag="span"

                      >

                        <img src={cd.id === activedropdownopen ? ActiveMoreIcon : InactiveMoreIcon} />


                      </DropdownToggle>
                      <DropdownMenu className="payment-dropdown" >
                        {!cd.default &&

                          <div className={`dropdown-item ${defaultCardLoading && popupDetails?.cdDetails?.id === cd?.id ? "disabled" : ""}`} onClick={onDefaultCard.bind(this, cd)}
                          >
                            <span className="api">Set as default</span>
                            {(defaultCardLoading && popupDetails?.cdDetails?.id === cd?.id) &&
                              <div className="spinner-container spinner-border">
                              </div>}
                          </div>}

                        <div className={`dropdown-item danger ${(cardRemoveLoading || defaultCardLoading) && popupDetails?.cdDetails?.id === cd?.id ? "disabled" : ""}`} onClick={onClickDeleteCard.bind(this, cd)}
                        >
                          <span className="api">Remove</span>
                          {(cardRemoveLoading && popupDetails?.cdDetails?.id === cd?.id) &&
                            <div className="spinner-container spinner-border">
                            </div>}
                        </div>
                      </DropdownMenu>
                    </Dropdown>
                  }
                </div>
              ))}
            </div>
          </div>

      }
      {
        popupDetails.open &&
        <CustomPopup
          popupDetails={popupDetails}
        />
      }
    </React.Fragment >
  )
}

export default withRouter(SavedCards)
